import { takeLatest, put, all, fork, call, delay } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import * as navFunc from "../../containers/Navbars/navFunc"

import * as actions from '../actions/actions'

import {login, logout, otp, resendOTPAPI} from '../../api/authenticationApi'

export default function* authenticationSaga() {
  yield all([
    fork(watchAuthenticationLoginRequest),
    fork(watchAuthenticationOtpRequest),
    fork(watchAuthenticationLogoutRequest),
    fork(watchExpireSessionRequest),
    fork(watchInvalidateSession),
    fork(watchResendOTP)
  ]);
}

function* watchAuthenticationLoginRequest() {
  yield takeLatest(
      actions.AUTHENTICATION_LOGIN_REQUEST,
      authenticationLoginRequest
  )
}

function* authenticationLoginRequest(loginData) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  yield put({ type: actions.AUTHENTICATION_CLEAN_ERROR})
  try {
    let { data } = yield call(login, loginData.value)
    yield put({ type: actions.AUTHENTICATION_LOGIN_SUCCESS, value: data })
    yield put(push(`/otp`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.AUTHENTICATION_LOGIN_FAILURE, error: error.response })
      yield put(push(`/${localStorage.getItem('bank')}`))
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}

function* watchExpireSessionRequest(){
  yield takeLatest(
      actions.EXPIRE_SESSION,
      expireSession
  )
}

function* expireSession() {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  yield put({ type: actions.AUTHENTICATION_LOGOUT_SUCCESS})
  yield put({ type: actions.CLEAN_ERROR })
  yield put({ type: actions.PROGRESS_STOP_REQUEST })
  localStorage.removeItem('state');
  localStorage.removeItem('token');
  localStorage.removeItem('expirationDate');
  localStorage.removeItem('userId');
  yield put(push(`/${localStorage.getItem('bank')}`))

}


function* watchAuthenticationLogoutRequest() {
  yield takeLatest(
      actions.AUTHENTICATION_LOGOUT_REQUEST,
      authenticationLogoutRequest
  )
}

function* authenticationLogoutRequest(token) {
  let bankLoginUrl = navFunc.bankLogoutRedirect(localStorage.getItem('bank'));
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(logout, token.value)
    yield put({ type: actions.AUTHENTICATION_LOGOUT_SUCCESS, value: data })
    localStorage.removeItem('state');
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');
    yield put(push(bankLoginUrl))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    yield put({ type: actions.AUTHENTICATION_LOGOUT_FAILURE, error: error.response })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  }
}

function* watchAuthenticationOtpRequest() {
  yield takeLatest(
      actions.AUTHENTICATION_OTP_REQUEST,
      authenticationOtpRequest
  )
}

function* authenticationOtpRequest(otpData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  yield put({ type: actions.AUTHENTICATION_CLEAN_ERROR})
  try {
    let { data } = yield call(otp, otpData.value)
    yield put({ type: actions.AUTHENTICATION_OTP_SUCCESS, value: data })
    yield put(push(`/index`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.AUTHENTICATION_OTP_FAILURE, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}


function* watchInvalidateSession() {
  yield takeLatest(
      actions.AUTHENTICATION_INVALIDATE_SESSION,
      invalidateSession
  )
}

function* invalidateSession() {
  let bankLoginUrl = navFunc.bankLogoutRedirect(localStorage.getItem('bank'));
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let data="";
    yield put({ type: actions.AUTHENTICATION_LOGOUT_SUCCESS, value: data })
    localStorage.removeItem('state');
    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate');
    localStorage.removeItem('userId');
    localStorage.removeItem('bank');
    yield put(push(bankLoginUrl))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    yield put({ type: actions.AUTHENTICATION_LOGOUT_FAILURE, error: error.response })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  }
}

function* watchResendOTP() {
  yield takeLatest(
      actions.AUTHENTICATION_RESEND_OTP,
      resendOTP
  )
}

function* resendOTP(otpData) {
  let bankLoginUrl = navFunc.bankLogoutRedirect(localStorage.getItem('bank'));
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(resendOTPAPI, otpData.value)
    // yield put({ type: actions.AUTHENTICATION_OTP_SUCCESS, value: data })
    // yield put(push(bankLoginUrl))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    yield put({ type: actions.AUTHENTICATION_OTP_FAILURE, error: error.response })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  }
}